export default __webpack_public_path__ + "static/media/ep2collage5.ca551236.jpg";